import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const message = {
  title: 'FF 91, Perfect!! | #FF 91 Performance',
  url: 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg',
  text: 'Racing 2000m above sea level as we head to Mexico City for this year\'s #F1ESTA 🥳 Adding more text here to cross two lines',
  avatar: 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg',
  platform: 'ff-icon-social-twitter',
  timestamp: {
    date: '2023-01-06T22:00:00.000Z',
    timezone: 'America/Los_Angeles'
  },
  user: 'Mute Worker(@Mute Worker)'
};
const assetBig = 'https://genesis-cdn.ff.com/Product_App/Image/responsive/Welcome_to_the_Future_of_Mobility-800w.jpg';
const assetSmall = 'https://genesis-cdn.ff.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg';

export const copySocialMediaMessageLayoutDefaultProps = {
  messages: [
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
    { ...message, asset: assetBig },
    { ...message, asset: assetSmall },
    { ...message, asset: assetSmall },
  ]
};

export const copySocialMediaMessageLayoutPropsSchema: PropsSchemaList = [
  {
    key: 'messages',
    label: 'Social Media Messages',
    type: types.ARRAY,
    children: [
      {
        key: 'asset',
        label: 'Image/Video Asset',
        type: types.S3_ASSET_URL
      },
      {
        key: 'url',
        label: 'Target URL',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
        options: {
          maxLength: 40
        }
      },
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
        options: {
          maxLength: 80
        }
      },
      {
        key: 'avatar',
        label: 'User Avatar Image',
        type: types.S3_ASSET_URL
      },
      {
        key: 'user',
        label: 'User Name',
        type: types.TEXT,
        options: {
          maxLength: 28
        }
      },
      {
        key: 'platform',
        label: 'Social Platform',
        type: types.ICON_SOCIAL
      },
      {
        key: 'timestamp',
        label: 'Message Datetime',
        type: types.DATETIME
      },
    ]
  },
];

export type LayoutProps = 'TextFirst' | 'ImageFirst';

export interface SlideProps {
  layout: LayoutProps;
  slideNumber?: {
    number: string;
    content: string;
  };
  asset?: {
    src: string;
    extendWidth: boolean;
    imageAlt?: string;
  }[];
  text?: {
    type: string;
    content: string;
  }[];
  link?: {
    src: string;
    appHandlerKey?: string;
    content: string;
  }[];
  button?: {
    src: string;
    appHandlerKey?: string;
    content: string;
  }[];
  socialFeed?: typeof copySocialMediaMessageLayoutDefaultProps;
}

export interface Props {
  slides: SlideProps[];
  learnMore?: {
    learnMoreText?: string;
    learnMoreFontSizeDesktop?: string;
    learnMoreFontSizeMobile?: string; 
  };
  socialLinks?: {
    mobileDeviceShareLink: {
      url: string;
      title: string;
      text: string;
      imageUrl?: string;
    };
    desktopDeviceShareLink: {
      icon: string;
      text: string;
      url: string;
    }[];
    desktopDeviceShareEmailLink: {
      icon: string;
      text: string;
      url: string;
      emailSubject: string;
      emailBody: string;
    }[];
  };
}

export const highlightsDefaultProps2: Props = {
  learnMore: {
    learnMoreText: 'Learn More >',
    learnMoreFontSizeDesktop: '16',
    learnMoreFontSizeMobile: '14',
  },
  slides: [
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '1',
        content: 'UNDETERMINED',
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'ONE CAR TO REPLACE SEDAN, SPORTS CAR AND SUV',
        },
        {
          type: 'paragraph',
          content:
            'The smooth, plush ride of a luxury sedan, sporty handling and power of a sports car, and the spaciousness and utility that comes with an SUV, the FF 91 Futurist combines the best of three worlds.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now',
        },
      ],
      button: [],
    },
    {
      layout: 'ImageFirst',
      slideNumber: {
        number: '2',
        content: 'UNDETERMINED',
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'INSIDE OUT DESIGN LANGUAGE',
        },
        {
          type: 'paragraph',
          content:
            'Contrary to the busy designs seen in the industry today, the FF 91 Futurist’s design starts from the interior. It is clean and simple… a mono-thematic theory that makes a precise statement of elegance and beauty',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now',
        },
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '3',
        content: 'UNDETERMINED',
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/View-5-copy-1-default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.15-2-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'UFO MODE MADE OF 10,000 LEDS',
        },
        {
          type: 'paragraph',
          content:
            'A lighting system that is unmatched, the FF 91 Futurist will display a unique, 3D crystal-like array that stands apart from anything else on the road; each individual LED is programmable, enabling customized lighting animations that communicates with the world around it.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now',
        },
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '4',
        content: 'UNDETERMINED',
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1--1--default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'SUPERIOR SAFETY',
        },
        {
          type: 'paragraph',
          content:
            'Safety is ingrained in every aspect of the FF 91 Futurist. Engineered from the ground up with the utmost safety in mind, starting with our patented VPA platform that provides a high-strength architecture.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now',
        },
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '5',
        content: 'UNDETERMINED',
      },
      asset: [],
      text: [
        {
          type: 'title',
          content: 'FF 91 Performance Comment',
        },
        {
          type: 'paragraph',
          content:
            'The FF 91 Futurist was crafted to perform with precision in any type of situation offering the possibilities for customization, based on the way the driver want to experience the vehicle in the moment; a synchronous and effortless approach to a personalized user experience.',
        },
      ],
      link: [],
      button: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now',
        },
      ],
      socialFeed: copySocialMediaMessageLayoutDefaultProps,
    },
  ],
  socialLinks: {
    mobileDeviceShareLink: {
      url: 'https://www.ff.com/us/ff-91/',
      title: 'Faraday Future - FF 91',
      text: 'Learn More about the FF 91',
      imageUrl: '',
    },
    desktopDeviceShareLink: [
      {
        icon: 'ff-icon-social-facebook',
        text: 'Facebook',
        url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-twitter',
        text: 'Twitter',
        url: 'https://twitter.com/intent/tweet?text=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-linkedin',
        text: 'LinkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.ff.com/us/ff-91/',
      },
    ],
    desktopDeviceShareEmailLink: [
      {
        icon: 'ff-icon-mail',
        text: 'Email',
        url: 'https://www.ff.com/us/ff-91/',
        emailSubject: 'Learn more about the FF 91',
        emailBody: 'Learn more about the FF 91 at https://www.ff.com/us/ff-91/',
      },
    ],
  },
};


export const highlightsDefaultProps3: Props = {
  learnMore: {
    learnMoreText: 'Learn More >',
    learnMoreFontSizeDesktop: '16',
    learnMoreFontSizeMobile: '14',
  },
  slides: [
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '1',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1--1--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: '1050 HP AND HYPERCAR LIKE 0-60 TIME'
        },
        {
          type: 'paragraph',
          content: 'At the heart of the FF 91 Futurist is a potent battery pack and Tri-motor powertrain capable of out-accelerating gravity, achieving maximum torque in 50 milliseconds – making it one of the most powerful EV propulsion systems in the world.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'ImageFirst',
      slideNumber: {
        number: '2',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1--2--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: 'BATTERY AND RANGE ΩAND CHARGING'
        },
        {
          type: 'paragraph',
          content: 'With a 142 kWh battery, FF 91 Futurist achieves an estimated range of 350 miles on the EPA cycle, which means you can drive it from Los Angeles to Silicon Valley, or New York City to Washington DC on a single charge.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '3',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1--2--default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'REAR STEER AND TORQUE VECTORING FUNCTIONALITY',
        },
        {
          type: 'paragraph',
          content: 'The ability to move all four wheels gives the FF 91 Futurist incredibly',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '4',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Turning-radius-default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.15-2-default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.16-11-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: '4 DRIVE MODES – ECO/SPORT/HYPER/HYPER LAUNCH',
        },
        {
          type: 'paragraph',
          content: 'he FF 91 Futurist was crafted to perform with precision in any type of situation offering the possibilities for customization, based on the way the driver want to experience the vehicle in the moment; a synchronous and effortless approach to a personalized user experience.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '5',
        content: 'UNDETERMINED'
      },
      asset: [],
      text: [
        {
          type: 'title',
          content: 'FF 91 Performance Comment',
        },
        {
          type: 'paragraph',
          content: 'The FF 91 Futurist was crafted to perform with precision in any type of situation offering the possibilities for customization, based on the way the driver want to experience the vehicle in the moment; a synchronous and effortless approach to a personalized user experience.'
        },
      ],
      link: [],
      button: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      socialFeed: copySocialMediaMessageLayoutDefaultProps,
    },
  ],
  socialLinks: {
    mobileDeviceShareLink: {
      url: 'https://www.ff.com/us/ff-91/',
      title: 'Faraday Future - FF 91',
      text: 'Learn More about the FF 91',
      imageUrl: '',
    },
    desktopDeviceShareLink: [
      {
        icon: 'ff-icon-social-facebook',
        text: 'Facebook',
        url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-twitter',
        text: 'Twitter',
        url: 'https://twitter.com/intent/tweet?text=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-linkedin',
        text: 'LinkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.ff.com/us/ff-91/',
      },
    ],
    desktopDeviceShareEmailLink: [
      {
        icon: 'ff-icon-mail',
        text: 'Email',
        url: 'https://www.ff.com/us/ff-91/',
        emailSubject: 'Learn more about the FF 91',
        emailBody: 'Learn more about the FF 91 at https://www.ff.com/us/ff-91/',
      },
    ],
  },
}

export const highlightsDefaultProps4: Props = {
  learnMore: {
    learnMoreText: 'Learn More >',
    learnMoreFontSizeDesktop: '16',
    learnMoreFontSizeMobile: '14',
  },
  slides: [
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '1',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1--3--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: 'MOBILE CONNECTIVITY'
        },
        {
          type: 'paragraph',
          content: 'FF 91’s living space keeps you connected and seamlessly integrates into your life with up to three 5G modems. The vehicle can offer a mobile hot spot for passengers to connect their personal devices and allow multiple users to share the 5G modems efficiently.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'ImageFirst',
      slideNumber: {
        number: '2',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1--4--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: 'WORLD OF SCREENS'
        },
        {
          type: 'paragraph',
          content: 'Revolutionary and Immersive Driving Experience coupled with an unsurpassed passenger experience – a total of 100” + across 11 displays including a 27-inch ultra-wide rear display to deliver a portal to passengers in every seat.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '3',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.15-2--1--default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.16-1-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'LIVE TV AND VIDEO CONFERENCING',
        },
        {
          type: 'paragraph',
          content: 'Live TV and Video conferencing utilizing the FF 91 Futurist’s onboard cameras and rear video screen – catch up on your favorite show, chat with your loved ones or conduct business when stuck in the traffic, the choice is yours.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '4',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1--3--default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'ZERO GRAVITY SEATS',
        },
        {
          type: 'paragraph',
          content: 'Stretch out and relax in the FF 91 Futurist’s Nasa-inspired Zero Gravity rear seats with 60-degree recline and the most rear legroom in its class.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '5',
        content: 'UNDETERMINED'
      },
      asset: [],
      text: [
        {
          type: 'title',
          content: 'FF 91 Performance Comment',
        },
        {
          type: 'paragraph',
          content: 'The FF 91 Futurist was crafted to perform with precision in any type of situation offering the possibilities for customization, based on the way the driver want to experience the vehicle in the moment; a synchronous and effortless approach to a personalized user experience.'
        },
      ],
      link: [],
      button: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      socialFeed: copySocialMediaMessageLayoutDefaultProps
    },
  ],
  socialLinks: {
    mobileDeviceShareLink: {
      url: 'https://www.ff.com/us/ff-91/',
      title: 'Faraday Future - FF 91',
      text: 'Learn More about the FF 91',
      imageUrl: '',
    },
    desktopDeviceShareLink: [
      {
        icon: 'ff-icon-social-facebook',
        text: 'Facebook',
        url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-twitter',
        text: 'Twitter',
        url: 'https://twitter.com/intent/tweet?text=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-linkedin',
        text: 'LinkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-mail',
        text: 'Copy Link',
        url: 'https://www.ff.com/us/ff-91/',
      },
    ],
    desktopDeviceShareEmailLink: [
      {
        icon: 'ff-icon-mail',
        text: 'Email',
        url: 'https://www.ff.com/us/ff-91/',
        emailSubject: 'Learn more about the FF 91',
        emailBody: 'Learn more about the FF 91 at https://www.ff.com/us/ff-91/',
      },
    ],
  },
}


export const highlightsDefaultProps5: Props = {
  learnMore: {
    learnMoreText: 'Learn More >',
    learnMoreFontSizeDesktop: '16',
    learnMoreFontSizeMobile: '14',
  },
  slides: [
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '1',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1--2--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: 'ADAS SENSORS INCLUDING LIDAR, RADAR, ULTRASONICS AND HIGH REZ CAMERAS'
        },
        {
          type: 'paragraph',
          content: 'FF 91 Futurist is equipped with 30+ advanced sensor fusion system and is prepared for autonomous driving from a hardware perspective, and once the world is ready for autonomous driving the FF 91 Futurist will be too.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'ImageFirst',
      slideNumber: {
        number: '2',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/vpa-8908-1--1--default.jpg',
          extendWidth: false,
        }
      ],
      text: [
        {
          type: 'title',
          content: 'ORIN COMPUTING CHIP, READY FOR AUTONOMOUS DRIVING'
        },
        {
          type: 'paragraph',
          content: 'FF 91 Futurist comes equipped with NVIDIA’s advanced Orin computing chip that is the ideal solution for powering various systems on the FF 91, including autonomous driving capabilities when the time is right.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '3',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/2016_CES_CHASSIS_FILM_FFcom_thumb-1--3--default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'FF AI',
        },
        {
          type: 'paragraph',
          content: 'FF 91 Futurist will offer an intelligent voice control system (AI) that is the future of human-vehicle interaction, moving us towards a voice-first experience in our vehicles and allowing complex commands to be carried out flawlessly.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '4',
        content: 'UNDETERMINED'
      },
      asset: [
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.15-1-default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.15-2--1--default.jpg',
          extendWidth: false,
        },
        {
          src: 'https://ff-genesis-cdn-dev.s3.amazonaws.com/product-page-highlights/Screen-Shot-2022-11-04-at-7.16-1-default.jpg',
          extendWidth: false,
        },
      ],
      text: [
        {
          type: 'title',
          content: 'RECOMMENDATION AND AGGREGATION ENGINE',
        },
        {
          type: 'paragraph',
          content: 'Content learning and recommendation system – FF aggregates video content from various sources and recommends the right content for you as it learns your preferences over time.',
        },
      ],
      link: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      button: [],
    },
    {
      layout: 'TextFirst',
      slideNumber: {
        number: '5',
        content: 'UNDETERMINED'
      },
      asset: [],
      text: [
        {
          type: 'title',
          content: 'FF 91 Performance Comment',
        },
        {
          type: 'paragraph',
          content: 'The FF 91 Futurist was crafted to perform with precision in any type of situation offering the possibilities for customization, based on the way the driver want to experience the vehicle in the moment; a synchronous and effortless approach to a personalized user experience.'
        },
      ],
      link: [],
      button: [
        {
          src: 'https://www.ff.com/us/preorder',
          content: 'Preorder Now'
        }
      ],
      socialFeed: copySocialMediaMessageLayoutDefaultProps
    },
  ],
  socialLinks: {
    mobileDeviceShareLink: {
      url: 'https://www.ff.com/us/ff-91/',
      title: 'Faraday Future - FF 91',
      text: 'Learn More about the FF 91',
      imageUrl: ''
    },
    desktopDeviceShareLink: [
      {
        icon: 'ff-icon-social-facebook',
        text: 'Facebook',
        url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-twitter',
        text: 'Twitter',
        url: 'https://twitter.com/intent/tweet?text=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-social-linkedin',
        text: 'LinkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.ff.com/us/ff-91/',
      },
      {
        icon: 'ff-icon-mail',
        text: 'Copy Link',
        url: 'https://www.ff.com/us/ff-91/',
      },
    ],
    desktopDeviceShareEmailLink: [
      {
        icon: 'ff-icon-mail',
        text: 'Email',
        url: 'https://www.ff.com/us/ff-91/',
        emailSubject: 'Learn more about the FF 91',
        emailBody: 'Learn more about the FF 91 at https://www.ff.com/us/ff-91/',
      },
    ],
  },
}
